"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _GhostIconButton = _interopRequireDefault(require("../Buttons/GhostIconButton"));
var _Link = _interopRequireDefault(require("../Typography/Link"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
var _base = require("../Icons/components/base");
var _excluded = ["segments", "linksAs", "onBack"],
  _excluded2 = ["name"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /**
   * An array of elements, each representing a segment of the Breadcrumbs.
   *
   * Each segment will be represented  as a link or plain text if it's the last one.
   *
   * All keys of the segment object, except the name, are spread on the link, so you can pass what you need (href, path, to etc.)
   */
  segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string
  })),
  /**
   * Function to execute on Back button click
   */
  onBack: _propTypes["default"].func,
  /**
   * Component to be used for the links, e.g. the NavLink from react-router
   */
  linksAs: _propTypes["default"].any
};
exports.propTypes = propTypes;
var Breadcrumbs = function Breadcrumbs(_ref) {
  var segments = _ref.segments,
    linksAs = _ref.linksAs,
    onBack = _ref.onBack,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    d: "flex",
    mB: "base",
    alignItems: "center",
    gap: "s"
  }, other), /*#__PURE__*/_react["default"].createElement(_GhostIconButton["default"], {
    name: "ArrowLeft",
    color: "text",
    hoverColor: "focus",
    label: "Back",
    onClick: onBack,
    key: "back"
  }), segments.map(function (segment, index) {
    var name = segment.name,
      linkProps = _objectWithoutProperties(segment, _excluded2);
    return index < segments.length - 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], _extends({
      color: "textSecondary",
      hoverColor: "focus",
      as: linksAs || "a"
    }, linkProps), segment.name), /*#__PURE__*/_react["default"].createElement(_base.ChevronRight, {
      color: "textSecondary",
      size: "xs"
    })) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      color: "textSecondary",
      key: index
    }, segment.name);
  }));
};
Breadcrumbs.propTypes = propTypes;
var _default = Breadcrumbs;
exports["default"] = _default;